import React from "react";
import * as constants from "@redbubble/design-system/react/constants";
import Avatar from "@redbubble/design-system/react/Avatar";
import Box from "@redbubble/design-system/react/Box";
import Text from "@redbubble/design-system/react/Text";
import styles from "./CommentsSection.scss";

const CommentsLoadingState = () => {
  const placeholder = [
    {
      id: 1,
      authorAvatar:
        "https://redbubble-static.redbubble.net/assets/rb-default-avatar.140x140-74f9462fbe8b15d59e89ceee5733a3ca6eada009a9db21b08fa72598fa820909.png",
      authorUsername: "username",
      comment: "Add a comment and show the artist your appreciation.",
      createdAt: "almost 1 year ago",
    },
    {
      id: 2,
      authorAvatar:
        "https://redbubble-static.redbubble.net/assets/rb-default-avatar.140x140-74f9462fbe8b15d59e89ceee5733a3ca6eada009a9db21b08fa72598fa820909.png",
      authorUsername: "username no 2",
      comment: "Gorgeous work! I love your colours!",
      createdAt: "6 months ago",
    },
    {
      id: 3,
      authorAvatar:
        "https://redbubble-static.redbubble.net/assets/rb-default-avatar.140x140-74f9462fbe8b15d59e89ceee5733a3ca6eada009a9db21b08fa72598fa820909.png",
      authorUsername: "username",
      comment: "I love your colours!!!",
      createdAt: "almost 1 year ago",
    },
    {
      id: 4,
      authorAvatar:
        "https://redbubble-static.redbubble.net/assets/rb-default-avatar.140x140-74f9462fbe8b15d59e89ceee5733a3ca6eada009a9db21b08fa72598fa820909.png",
      authorUsername: "username no 4",
      comment: "Add a comment and show the artist your appreciation.",
      createdAt: "5 minutes ago",
    },
    {
      id: 5,
      authorAvatar:
        "https://redbubble-static.redbubble.net/assets/rb-default-avatar.140x140-74f9462fbe8b15d59e89ceee5733a3ca6eada009a9db21b08fa72598fa820909.png",
      authorUsername: "username",
      comment: "I think this is great",
      createdAt: "almost 1 year ago",
    },
  ];

  return (
    <Box className={styles.commentsContainer}>
      {placeholder.map(
        ({ id, authorAvatar, authorUsername, comment, createdAt }) => {
          return (
            <Box marginBottom="l" key={`LoadingComment=${id}`}>
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                justifyContent="space-between"
                paddingRight="xs"
                paddingLeft="xs"
                paddingBottom="l"
              >
                <Box display="flex" flexDirection="row" alignItems="center">
                  <Avatar src={authorAvatar} size={constants.TINY} loading />
                  <Box marginLeft="xs">
                    <Text type="display5" loading>
                      {authorUsername}
                    </Text>
                  </Box>
                </Box>
                <Box>
                  <Text type="caption" muted loading>
                    {createdAt}
                  </Text>
                </Box>
              </Box>
              <Box className={styles.loadingMessageBoxWrapper}>
                <Box className={styles.messageBoxTriangleWrapper}>
                  <Box className={styles.messageBoxGreyTriangle} />
                  <Box className={styles.messageBoxWhiteOverlay} />
                </Box>
                <Box
                  className={`${styles.messageBoxLayout} ${styles.messageBox}`}
                >
                  <Text type="body">{comment}</Text>
                </Box>
              </Box>
            </Box>
          );
        }
      )}
    </Box>
  );
};

export default CommentsLoadingState;
